const STYLES = {
  draft: "bg-amber-100 text-amber-800 border-amber-200",
  dikirim: "bg-blue-100 text-blue-800 border-blue-200",
  diterima: "bg-emerald-100 text-emerald-800 border-emerald-200",
  dibatalkan: "bg-zinc-100 text-zinc-500 border-zinc-200",
  lunas: "bg-emerald-100 text-emerald-800 border-emerald-200",
  belum_lunas: "bg-amber-100 text-amber-800 border-amber-200",
};

const LABELS = {
  draft: "Draft",
  dikirim: "Sent",
  diterima: "Received",
  dibatalkan: "Cancelled",
  lunas: "Paid",
  belum_lunas: "Unpaid",
};

export function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STYLES[status] || STYLES.draft}`}
    >
      {LABELS[status] || status}
    </span>
  );
}
